import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FinalCTASection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative w-full bg-brand-bg py-24 md:py-32 px-6 overflow-hidden" data-id="element-219">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-green/5 rounded-full blur-[120px] pointer-events-none" data-id="element-220" />
      <div className="relative max-w-4xl mx-auto text-center" data-id="element-221">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-col items-center" data-id="element-222">
          <div className="relative" data-id="element-223">
            <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-224" />
            <motion.h2 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 mb-6 leading-tight relative z-10" data-id="element-225">
              Empezá hoy y construí tu{' '}
              <span className="text-[#1fa855]" data-id="element-226">negocio online</span> paso a paso
            </motion.h2>
          </div>
          <motion.p variants={itemVariants} className="text-lg md:text-xl text-brand-dark/70 mb-12 max-w-2xl" data-id="element-227">
            Sin experiencia, sin complicarte y con un método probado.
          </motion.p>
          <motion.a variants={itemVariants} href="#" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="group relative inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-white bg-brand-green rounded-full transition-all duration-300 hover:bg-brand-green-hover hover:scale-105 hover:-translate-y-1 shadow-[0_0_30px_rgba(20,184,166,0.3)] hover:shadow-[0_0_50px_rgba(20,184,166,0.5)] mb-12 cursor-pointer" data-id="element-228">
            <span className="mr-2 text-2xl group-hover:animate-bounce" data-id="element-229">🔥</span>
            Empezar Ahora
          </motion.a>
          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10" data-id="element-230">
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-231">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-232" />
              <span data-id="element-233">Acceso inmediato</span>
            </div>
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-234">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-235" />
              <span data-id="element-236">Pago 100% seguro con Mercado Pago</span>
            </div>
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-237">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-238" />
              <span data-id="element-239">Empezá hoy mismo</span>
            </div>
          </motion.div>
          <motion.p variants={itemVariants} className="text-xs md:text-sm text-brand-dark/40 uppercase tracking-widest font-medium" data-id="element-240">
            Acceso disponible por tiempo limitado
          </motion.p>
        </motion.div>
      </div>
    </section>;
}